/*
 * View for the topic label modal
 */

define(["jquery", "marionette", "./template/localeMapTemplate.html"], function (
  $,
  Marionette,
  LocaleMapTemplate,
) {
  "use strict";

  const LocaleMapView = {};

  LocaleMapView.localeMapView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: LocaleMapTemplate,
    events: {
      "click .chkDeleteLocale": function (e) {
        const languageId = this._getLanguageId(e);
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:locale:allowDelete", languageId);
      },
      "click .chkEditLocale": function (e) {
        const languageId = this._getLanguageId(e);
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:locale:allowEdit", languageId);
      },
      "click .chkViewLocale": function (e) {
        const languageId = this._getLanguageId(e);
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:locale:allowView", languageId);
      },
    },
    _getLanguageId: function (e) {
      //get the intent id of the topic by getting the custom data attribute
      const languageId = $(e.target).attr("data-languageId");
      //force it to be a number
      return +languageId;
    },
  });

  return LocaleMapView;
});
